module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"noEntries":"Noch keine Einträge vorhanden.","noResults":"Keine Treffer für „{search}“.","search":"Suche"},"en":{"noEntries":"No entries yet.","noResults":"No results for “{search}”.","search":"Search"}}')
  delete Component.options._Ctor
}
